import React from 'react';

const Body = () => (
    <>
        <h2>INFORMATION ABOUT OUR USE OF COOKIES</h2>Our websites (our "websites") are operated by
        JD Sports Fashion plc and its group companies (together "we", "us", "our", the "JD Group").
        The websites use cookies to distinguish you from other users and this helps us to provide
        you with a good experience when you browse our websites and also to improve our websites.
        <br />
        <br />
        If you wish to remove cookies placed on your device by our website or stop our website
        placing further cookies on your device, you can do this at any time.
        <br />
        By visiting our website with your browser settings adjusted to allow cookies you are
        acknowledging our use of essential cookies for the purposes outlined below in order to
        provide you with a fully functional, tailored user experience.<h2>What is a cookie?</h2>A
        cookie is a small text file which is downloaded and stored on your computer or mobile device
        by websites that you visit. Where cookie technology is not available, an anonymous
        identifier may be used. An anonymous identifier is a random string of characters used for
        the same purposes as a cookie.
        <br />
        <br />
        Your browser accesses the cookie file only when you visit the website that generated it.
        Cookies allow websites like ours to deliver you a personalised user experience.
        <br />
        <br />
        The information stored within any given cookie can only be accessed by the website that
        created it and cookies are limited to communicating only the information that you have
        disclosed to the site.
        <br />
        <br />
        Managing cookies: Enabling and Disabling. You can set your browser to refuse all or some
        browser cookies, or to alert you when websites set or access cookies. If you disable or
        refuse cookies, please note that some parts of this website may become inaccessible or not
        function properly.<h2>We use the following types of cookie</h2>Strictly necessary cookies.
        These are cookies that are required for the operation of our websites. They include, for
        example, cookies that enable you to log into secure areas of our websites or make purchases.
        We do not require your consent to place these cookies. Nevertheless, you may be able to
        block these cookies yourself on your device/ browser, but restricting these cookies is
        likely to mean that our websites will not work as you would expect and certain functionality
        may be inoperable.
        <br />
        <br />
        Analytical/performance cookies. They allow us to recognise and count the number of visitors
        and to see how visitors move around our websites when they are using it. This helps us to
        improve the way our websites work, for example, by ensuring that users are finding what they
        are looking for easily. We use cookies to compile visitor statistics such as how many people
        have visited our websites, how they reached our websites, what type of technology they are
        using (e.g. Mac or Windows which helps to identify when our site isn't working as it should
        for particular technologies), how long they spend on the websites, what page they look at
        etc. This helps us to continuously improve our websites.
        <br />
        <br />
        <table>
            <tr>
                <th>Category</th>
                <th>Cookie Duration</th>
                <th>Purpose</th>
                <th>Examples</th>
            </tr>
            <tr>
                <td>Essential Cookies</td>
                <td>12 months</td>
                <td>
                    These cookies are required for the operation and smooth running of our site,
                    they enable us to ensure you have no issues navigating the site. For example, we
                    use New Relic to capture page load times as well as request response time to
                    ensure that we are delivering a high quality of service.
                </td>
                <td>
                    Google Analytics
                    <br />
                    New Relic
                </td>
            </tr>
        </table>
        <br />
        For a full list of all cookie please refer to the below list:
        <br />
        <br />
        <table>
            <tr>
                <th>Name</th>
                <th>Cookie Type</th>
            </tr>
            <tr>
                <td>Google Analytics</td>
                <td>Essential</td>
            </tr>
            <tr>
                <td>NewRelic</td>
                <td>Essential</td>
            </tr>
        </table>
        <br />
        Any changes to this cookies policy in the future will be posted on this page and we will
        take all measures necessary to communicate any changes to this cookies policy to you.
        <br />
        <br />
        If you have any further questions, comments or requests regarding our cookies policy or how
        we use cookies on our website, then you can{' '}
        <a className="link" href="/contact-us">
            contact us
        </a>
        .<br />
        <br />
        This policy was last reviewed and updated: August 2019
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/privacy.jpg',
    body: Body,
};
